module.exports = {
	...require('./stepExercise'),
	...require('./simpleExercise'), // simpleExercise is mostly a special case of stepExercise. It uses its functionalities.
}
